import React from 'react';
import { siteData } from '../data';

const facilities = [
  { icon: '📚', title: 'Smart Classrooms', desc: 'Smart boards, projectors, AC, hygienic environment' },
  { icon: '👩‍🏫', title: 'Expert Faculty', desc: '15–24+ years experienced teachers with mentoring' },
  { icon: '🔬', title: 'Computer Labs', desc: 'High-speed internet, latest software, modern hardware' },
  { icon: '📖', title: 'Library', desc: 'Books, exam prep material, silent study zone' },
  { icon: '🛡️', title: 'Safety', desc: 'CCTV surveillance, disciplined campus, first-aid' },
  { icon: '💻', title: 'Online Support', desc: 'Online classes, PDF materials, WhatsApp updates' },
];

const whyUs = [
  '✦  24+ years of continuous service — established 2001',
  '✦  4.9/5 rating from 15000+ verified student reviews',
  '✦  NIELIT affiliated & government recognized certificates',
  '✦  400+ courses across 12+ categories',
  '✦  4+ branches across Saharanpur for easy access',
  '✦  Expert faculty with 15–24+ years of experience',
  '✦  Modern labs with latest licensed software',
  '✦  Practical, job-oriented training methodology',
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 relative" style={{background:'#0F1629'}}>
      <div className="orb w-96 h-96 -top-40 right-0 opacity-10" style={{background:'rgba(200,168,75,0.4)'}} />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div className="reveal-left">
            <span className="section-tag">About ITS Academy</span>
            <h2 className="font-playfair font-black text-white leading-tight mb-6" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(2rem,3.5vw,3rem)'}}>
              Saharanpur's Premier<br/>
              <span style={{color:'#C8A84B'}}>Computer Education</span> Institute
            </h2>
            <p className="leading-relaxed mb-4" style={{color:'rgba(212,207,197,0.7)'}}>
              ITS Academy has been empowering students and professionals since <strong className="text-white">July 2001</strong>. Located at Chipiyan, Chakrota Road, Saharanpur, we have grown from a single centre to <strong className="text-white">4+ branches</strong> across Saharanpur — each delivering hands-on, job-oriented education.
            </p>
            <p className="leading-relaxed" style={{color:'rgba(212,207,197,0.7)'}}>
              With experienced faculty, modern infrastructure, and <strong className="text-white">government-recognized certifications</strong>, we prepare students to succeed in today's digital economy.
            </p>
          </div>

          {/* Visual side */}
          <div className="reveal-right relative">
            <div className="relative rounded-sm overflow-hidden" style={{height:'360px'}}>
              {/* <div className="img-placeholder w-full h-full">
                <div className="text-6xl">🏫</div>
                <span>About Us Photo</span>
                <span style={{fontSize:'0.65rem',color:'rgba(212,207,197,0.3)'}}>public/images/about.jpg</span>
              </div> */}
                 <img src="/images/logos/About.png" className="w-full h-full object-contain" alt="ITS Academy About Us" />
              {/* Year badge */}
              <div className="absolute top-6 left-6 px-4 py-3 rounded-sm" style={{background:'#C8A84B'}}>
                <div className="font-black text-black leading-none" style={{fontFamily:'Playfair Display,serif',fontSize:'2.5rem'}}>2001</div>
                <div className="text-black text-xs tracking-widest uppercase font-bold">Founded</div>
              </div>
            </div>
            {/* Rating float */}
            <div className="absolute -bottom-5 -right-5 glass-card p-5 rounded-sm text-center" style={{borderColor:'rgba(200,168,75,0.25)',minWidth:'160px'}}>
              <div className="font-black leading-none mb-1" style={{fontFamily:'Playfair Display,serif',fontSize:'3rem',color:'#C8A84B'}}>4.9</div>
              <div className="flex justify-center gap-0.5 mb-1">
                {[1,2,3,4,5].map(i=><span key={i} style={{color:'#C8A84B',fontSize:'0.7rem'}}>★</span>)}
              </div>
              <div style={{fontSize:'0.68rem',color:'rgba(212,207,197,0.4)',letterSpacing:'1px'}}>1500+ Reviews</div>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="reveal mb-20">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            <div>
              <h3 className="font-playfair font-bold text-white text-2xl mb-6" style={{fontFamily:'Playfair Display,serif'}}>
                Why Choose <span style={{color:'#C8A84B'}}>ITS Academy?</span>
              </h3>
              <ul className="space-y-3">
                {whyUs.map((item, i) => (
                  <li key={i} className="flex items-start gap-3 py-3 border-b" style={{borderColor:'rgba(200,168,75,0.08)',color:'rgba(212,207,197,0.75)',fontSize:'0.9rem'}}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Branches */}
            <div>
              <h3 className="font-playfair font-bold text-white text-2xl mb-6" style={{fontFamily:'Playfair Display,serif'}}>
                Our <span style={{color:'#C8A84B'}}>Branches</span>
              </h3>
              <div className="space-y-3">
                {siteData.allBranches.map((branch, i) => (
                  <div key={i} className="p-4 rounded-sm transition-all duration-300 hover:border-yellow-500/40 cursor-default" style={{background:'rgba(255,255,255,0.03)',border:'1px solid rgba(200,168,75,0.12)'}}>
                    <div className="flex items-center gap-3">
                      <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-black flex-shrink-0" style={{background:'#C8A84B'}}>
                        {i === 0 ? 'HO' : `B${i}`}
                      </div>
                      <div>
                        <div className="text-white font-semibold text-sm mb-0.5">{branch.label}</div>
                        <div style={{color:'rgba(212,207,197,0.5)',fontSize:'0.8rem',lineHeight:'1.5'}}>{branch.address}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Facility Grid */}
        <div className="reveal">
          <span className="section-tag">World-Class Infrastructure</span>
          <h3 className="font-playfair font-bold text-white text-2xl mb-8" style={{fontFamily:'Playfair Display,serif'}}>
            Our <span style={{color:'#C8A84B'}}>Facilities</span>
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-[2px]">
            {facilities.map((f, i) => (
              <div key={i} className="p-6 hover-lift border transition-all duration-300 cursor-default" style={{background:'rgba(15,22,41,0.8)',border:'1px solid rgba(200,168,75,0.1)'}}>
                <div className="text-3xl mb-3">{f.icon}</div>
                <div className="text-white font-semibold mb-2 text-sm">{f.title}</div>
                <div style={{color:'rgba(212,207,197,0.5)',fontSize:'0.8rem',lineHeight:'1.6'}}>{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
